import styled from 'styled-components';

// MUI renders the closed field from the selected item's children rather than
// from the item itself, so the icon and label are laid out one level in — that
// way the menu row and the closed field space them identically.
const OptionContent = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export { OptionContent };
